<template>
  <nav class="navbar navbar-light navbar-expand-lg fixed-top py-3">
    <div class="container-fluid">
      <router-link
        :to="{ name: 'index' }"
        class="navbar-brand me-4"
        data-test="navbar-brand"
      >
        <div class="d-flex">
          <template v-if="moodysBranded">
            <img
              src="../images/moodys.png"
              alt="Moody's"
              class="hidden-xs"
              style="height: auto; object-fit: contain; max-height: 65px;"
            >
            <div
              class="d-flex flex-column justify-content-start border-start border-dark ps-3 ms-3 hidden-xs"
            >
              <div style="font-size: 1rem; line-height: 1;">
                <small><small><em>Powered by</em></small></small>
              </div>
              <img
                src="../images/logo.png"
                alt="Profound"
                style="height: auto; object-fit: contain; max-height: 43px; max-width: 200px; margin-top: -8px;"
              >
            </div>
          </template>
          <img
            v-else
            src="../images/logo.png"
            alt="Profound"
            class="hidden-xs"
            style="height: auto; object-fit: contain; max-height: 65px;"
          >
        </div>
      </router-link>
      <div class="collapse navbar-collapse">
        <ul class="navbar-nav">
          <li class="nav-item active">
            <router-link
              class="nav-link"
              :to="{ name: 'newJobFileForm' }"
            >
              Start New Job
            </router-link>
          </li>
          <li class="nav-item active">
            <router-link
              class="nav-link"
              :to="{ name: 'importJobResults' }"
            >
              Import Existing Report
            </router-link>
          </li>
          <li class="nav-item active">
            <router-link
              class="nav-link"
              :to="{ name: 'presets' }"
            >
              Presets
            </router-link>
          </li>
        </ul>
      </div>
      <div class="h3 mb-0">
        {{ filename }}
      </div>
    </div>
  </nav>
</template>

<script>
export default {
  data: () => ({ filename: null, moodysBranded: false }),
  watch: {
    filename(value) {
      document.title = value || "CSV Analyzer";
    },
  },
};
</script>
